export default{
    apiKey: "AIzaSyBZM8rQeyRlAeNkkRvpi_Tyj0xQpVOIyAk",
    authDomain: "infoplayersaoe.firebaseapp.com",
    databaseURL: "https://infoplayersaoe-default-rtdb.firebaseio.com",
    projectId: "infoplayersaoe",
    storageBucket: "infoplayersaoe.appspot.com",
    messagingSenderId: "876194036529",
    appId: "1:876194036529:web:5a3ded9b735cb5d96fce10",
    measurementId: "G-D6HZB9LVLV"
}